import { render, staticRenderFns } from "./ObjectDeleteModal.vue?vue&type=template&id=e8aa6948&"
import script from "./ObjectDeleteModal.vue?vue&type=script&lang=js&"
export * from "./ObjectDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports